export const apiPath = '/v1/transfer_events';
const actionType = 'TRANSFER_EVENT';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
